import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { PIPImplmentsLevelVM, userAlertsVM } from '../../GET_NEW_UI/entities/global/model';
import { ProgramImprovementService } from '../../GET_NEW_UI/services/program-improvement.service';
import { PreferencesService } from '../../preferences/preferences.service';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-pip-for-dashboard',
  templateUrl: './pip-for-dashboard.component.html',
  styleUrls: ['./pip-for-dashboard.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class PipForDashboardComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PipForDashboardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
     private _programImprovementService :ProgramImprovementService,
     private _notify: NotificationsService,
     private readonly _pref: PreferencesService,
     private _router: Router,) { }

     GET_Auto:number[]
     PIPImplmentsLevelList_:PIPImplmentsLevelVM[]
     userAlertslist:userAlertsVM[]
     userAlertslist_:userAlertsVM[]
     checkedStatus:boolean=false
     status:number
     showClearHistoryButton:boolean=false


  ngOnInit() {
    this.GET_Auto=this.data.GET_Auto
    this.getCurrentUserAlertsforDashboard();
    this.getHistoryUserAlertsforDashboard();
  }
  onCloseClick(): void {
    this.dialogRef.close();
  }

  getCurrentUserAlertsforDashboard()
  {
  
    this._programImprovementService.getCurrentUserAlertsforDashboard().subscribe(res=>{
      console.log(res)
       
      this.userAlertslist=res
      this.showClearHistoryButton=false
  })
  }
  getHistoryUserAlertsforDashboard(){
    this._programImprovementService.getHistoryUserAlertsforDashboard().subscribe(res=>{
      console.log(res)
       
      this.userAlertslist_=res
      this.showClearHistoryButton=true
  })
  }
    
  openProdImprovementAssetScreen(Link) {
   // console.log(desc.split(":")[1])       
     // window.open(Link, '_blank');

     this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate([Link]);
      }else{             
        window.open(Link, '_blank');
       
      }
  });
         
 
  }



  checkboxChanged(event, ID){
    console.log(event.checked)
    if(event.checked==true){
      this.status=2
      this._programImprovementService.changeAlertStartus(ID, this.status).subscribe(res=>{
        if(res==true) {
          this.getCurrentUserAlertsforDashboard()
          this.getHistoryUserAlertsforDashboard()
        }
            })
    }
    else if(event.checked==false){
        this.status=1
        this._programImprovementService.changeAlertStartus(ID, this.status).subscribe(res=>{
          if(res==true) {
            this.getCurrentUserAlertsforDashboard()
            this.getHistoryUserAlertsforDashboard()
          }
              })
      }

    //  this.getCurrentUserAlertsforDashboard();
     // this.getHistoryUserAlertsforDashboard();
    }
    
    ClearHistory(){
      this._programImprovementService.clearHistory().subscribe(res=>{
       if(res==true){
        this._notify.success('Records have been successfully removed');
        this.getHistoryUserAlertsforDashboard()
       }
      })
      
    }
}
